import React, {Component} from 'react';
import Loading from "../lib/steps_components/common/Loading";
import API from "../api";


class GeneralInfo extends Component {
    constructor(props) {
        super(props);
        const {settings} = this.props.store;
         let optionValue = this.props.steps.option.value;

        let message = "";
        let phonefax = false;
        switch (optionValue) {
            case "ClinicPhoneFax":
                message = settings.generalInfo.clinic_phone +"<br>"+settings.generalInfo.clinic_fax;
                phonefax = true;
                break;


            case "ClinicEmail":
                message = settings.generalInfo.clinic_email;
                break;

            case "HowToArrive":
                message = settings.generalInfo.clinic_how_to_arrive_explanation;
                break;

            case "ClinicAddress":
                message = settings.generalInfo.clinic_address;
                break;

        }
        this.state = {
            generalInfo:{},
            settings: settings,
            optionValue: optionValue,
            message: message,
            phonefax: phonefax
        }

    }

    componentWillMount() {

    }


    render() {


        const {message,phonefax} = this.state;




        return (
            phonefax ?(<div dangerouslySetInnerHTML={{__html:message}}/>):( <div>
                {message}

            </div>)
        );
    }
}


export default GeneralInfo;